const ssoDomains = [
  {
    'altre.com.br': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-altre.png',
      title: 'Altre',
    },
    'aurenergia.com.br': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-auren.png',
      title: 'Auren',
    },
    'cba.com.br': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-cba.png',
      title: 'cba',
    },
    'nexaresources.com': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-nexa.png',
      title: 'Nexa',
    },
    'memoriavotorantim.com': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-votorantim.png',
      title: 'Memória Votorantim',
    },
    'votorantim.com': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-votorantim.png',
      title: 'Votorantim',
    },
    'institutovotorantim.org.br': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-instituto-votorantim.png',
      title: 'Instituto Votorantim',
    },
    'acerbrag.com': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-acerbrag.png',
      title: 'Acerbrag',
    },
    'legadodasaguas.com.br': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-legado-das-aguas.png',
      title: 'Legado das Águas',
    },
    'reservasvotorantim.com.br': {
      url: '/saml2/1f20a6f2-33cb-4e9a-9cb7-52f1560295e8/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/517f0f5e-89ce-46e4-a9c5-934ebd8d7b2f/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-reservas-votorantim.png',
      title: 'Reservas Votorantim',
    },
    'citrosuco.com': {
      url: '/saml2/74f4982e-61b5-4f25-a3bd-8f31f002d86b/login?returnTo=https://voluntarios.votorantim.com.br/minha-unidade',
      urlHomolog: '/saml2/898fb2c4-bec0-400f-b2ab-911ab88e79e2/login?returnTo=https://dv.labforgood.com.br/minha-unidade',
      logo: '/images/logos/logo-votorantim.png',
      title: 'Citrosuco'
    }
  }
];

const $ssoImg = $('.js-sso-img');
const $ssoTitle = $('.js-sso-title');
const baseURl = window.location.origin;

export default function setNextUrl(email, defaultUrl) {
  const emailDomain = email.split('@')[1];
  const domainObject = ssoDomains.find(domain => domain[emailDomain]);

  if (domainObject) {
    const domain = domainObject[emailDomain];
    $ssoImg.attr('src', domain.logo).attr('alt', domain.title);
    $ssoTitle.text(domain.title);

    if (baseURl.includes('voluntarios.votorantim')) {
      return `${baseURl}${domain.url}`;
    } else {
      return `${baseURl}${domain.urlHomolog}`;
    }
  } else {
    return defaultUrl;
  }
}